<template>
  <div>
    <div class="owner_title">写手公海信息</div>
    <!-- 筛选 -->
    <div class="task_filtrate" @click="show_filter_form()">
      <i class="iconfont icon-shaixuan1"></i>
      <span>筛选</span>
    </div>

    <!-- 筛选表单 -->
    <div class="task_filter_form" v-show="isFilterForm">
      <el-form
        ref="filter_form"
        :model="filter_form"
        :inline="true"
        class="demo-form-inline"
        label-width="100px"
      >
        <el-form-item label="创建时间">
          <el-date-picker
            v-model="filter_form.createtime"
            value-format="yyyy-MM-dd HH:mm:ss"
            :default-time="['00:00:00', '23:59:59']"
            type="datetimerange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          >
          </el-date-picker>
        </el-form-item>
        <el-button type="primary" icon="el-icon-search" @click="goSearch"
          >搜索</el-button
        >
      </el-form>
    </div>

    <div class="seas_box">
      <!-- 表格数据    -->
      <el-table
        height="650"
        ref="multipleTable"
        :data="dataShow"
        border
        style="width: 100%"
      >
        <el-table-column type="index" label="序号" align="center" width="50">
        </el-table-column>

        <el-table-column
          prop="connectionlabel_text"
          align="center"
          label="写手标签"
          width="150"
          sortable
        >
          <template slot-scope="scope">
            <el-tag
              :key="item"
              v-for="item in scope.row.connectionlabel_text"
              type="info"
            >
              {{ item }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column
          prop="createtime"
          align="center"
          label="创建时间"
          sortable
        >
        </el-table-column>
        <el-table-column
          :fixed="equipmentType == 1 ? false : 'right'"
          label="操作"
          align="center"
          width="320"
        >
          <template slot-scope="scope">
            <div class="sea_box">
              <div @click="goMyWriter(scope.row)" class="mywriter_btn">
                <i class="iconfont icon-zhuanru"></i>
                <span>转入我的写手</span>
              </div>
              <div @click="historyRemark(scope.row)" class="remark_btn">
                <i class="iconfont icon-jilu"></i>
                <span>历史备注</span>
              </div>
            </div>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <el-pagination
        class="pagination_box"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>

      <!-- 历史备注弹窗 -->
      <el-dialog
        :visible.sync="historyDialogVisible"
        title="历史备注"
        @close="cancelDialog"
        width="40%"
      >
        <el-table :data="dataShowDialog" border>
          <el-table-column type="index" label="序号" align="center" width="50">
          </el-table-column>
          <el-table-column
            property="departmentuser_name"
            sortable
            label="备注人"
            align="center"
          ></el-table-column>
          <el-table-column
            property="remark"
            sortable
            align="center"
            label="备注内容"
          ></el-table-column>
          <el-table-column
            property="createtime"
            sortable
            align="center"
            label="备注时间"
          ></el-table-column>
        </el-table>
        <el-pagination
          @size-change="handleSizeChangeDialog"
          @current-change="handleCurrentChangeDialog"
          :current-page="currentPageDialog"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pageSizeDialog"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalDialog"
        >
        </el-pagination>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import {
  writer_list,
  change_writer,
  writer_connectionremark_list
} from "@/utils/writer";
export default {
  data() {
    return {
      writerId: "", //所属写手部id
      infoList: [], //公海信息列表
      isFilterForm: true, //筛选表单
      historyDialogVisible: false, //历史备注弹窗
      dataShow: [], // 当前页要显示的数据,//显示的金主列表数据
      totalPageData: [], // 分页数据(全部数据已经分好页)
      pageNum: 1, // 共几页
      pageSize: 100, // 每页显示数量
      currentPage: 1, // 当前显示页码
      total: 1, // 总共多少条数据
      dataShowDialog: [], // 当前页要显示的数据,//显示的金主列表数据
      totalPageDataDialog: [], // 分页数据(全部数据已经分好页)
      pageNumDialog: 1, // 共几页
      pageSizeDialog: 10, // 每页显示数量
      currentPageDialog: 1, // 当前显示页码
      totalDialog: 1, // 总共多少条数据
      // 筛选
      filter_form: {
        nickname: "", //写手昵称
        name: "", //写手姓名
        qq_account: "", //写手QQ
        alipay_account: "", //写手支付宝
        mobile: "", //写手电话号码
        createtime: "" //创建时间范围
      },
      select_time_data: "",
      time_filter: "", //时间筛选

      equipmentType: 0 //判断移动端还是pc端  0：pc  1：移动
    };
  },
  created() {
    this.writerId = JSON.parse(localStorage.getItem("userInfo")).id;
    if (this.$isMobile.isDeviceType()) {
      this.equipmentType = 1;
      this.dialogWidth = "90%";
    } else {
      this.equipmentType = 0;
      this.dialogWidth = "40%";
    }
    this.getWriterList();
  },

  methods: {
    // 获取接单中心列表
    getWriterList() {
      var that = this;
      let obj = {
        departmentuser_id: that.writerId,
        page: 1,
        page_index: 10
      };
      writer_list(obj).then(res => {
        if (res.data.code == 1) {
          that.total = res.data.data.length;
          that.infoList = res.data.data;
          that.calcPageData(that.infoList, 0);
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },

    //  转入我的写手
    goMyWriter(val) {
      var that = this;
      let obj = {
        departmentuser_id: that.writerId,
        writer_id: val.id
      };
      change_writer(obj).then(res => {
        if (res.data.code == 1) {
          this.$message.success(res.data.msg);
          that.$router.push("/myWriter");
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    // 获取历史备注
    historyRemark(val) {
      var that = this;
      that.historyDialogVisible = true;
      let obj = {
        departmentuser_id: that.writerId,
        writer_id: val.id
      };
      writer_connectionremark_list(obj).then(res => {
        if (res.data.code == 1) {
          that.totalDialog = res.data.data.length;
          that.historyList = res.data.data;
          that.calcPageDataDialog();
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    // 打开筛选表单
    show_filter_form() {
      var that = this;
      that.isFilterForm = !that.isFilterForm;
    },
    // 筛选
    goSearch(val) {
      var that = this;
      var date1, date2;
      that.select_time_data = that.filter_form.createtime;
      date1 = that.select_time_data[0];
      date2 = that.select_time_data[1];
      if (val == 0) {
        var time1, time2;
        time1 = that.select_time_data[0];
        time2 = that.select_time_data[1];
        that.time_filter = time1 + " - " + time2;
        that.filter_form.createtime = that.time_filter;
        console.log("刷新", that.select_time_data);
      } else {
        console.log("第一次进入页面");
        if (date1 == undefined && date2 == undefined) {
          that.time_filter = "";
        } else {
          that.time_filter = date1 + " - " + date2;
        }
        console.log("that.time_filter", that.time_filter);
        that.filter_form.createtime = that.time_filter;
      }

      let obj = {
        departmentuser_id: that.writerId,
        page: 1,
        page_index: 10,
        ...that.filter_form
      };
      writer_list(obj).then(res => {
        if (res.data.code == 1) {
          that.total = res.data.data.length;
          that.infoList = res.data.data;
          that.calcPageData();
          that.filter_form.createtime = that.select_time_data;
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    // 关闭弹窗触发
    cancelDialog() {
      if (this.select_time_data) {
        console.log("有值");
        this.goSearch(0);
      } else {
        this.goSearch();
      }
    },
    calcPageData() {
      if (this.infoList.length > 1) {
        this.pageNum = Math.ceil(this.infoList.length / this.pageSize) || 1;
      }
      for (let i = 0; i < this.pageNum; i++) {
        this.totalPageData[i] = this.infoList.slice(
          this.pageSize * i,
          this.pageSize * (i + 1)
        );
      }

      this.dataShow = this.totalPageData[this.currentPage - 1];
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.calcPageData();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.dataShow = this.totalPageData[val - 1];
    },
    calcPageDataDialog() {
      if (this.historyList.length > 1) {
        this.pageNumDialog =
          Math.ceil(this.historyList.length / this.pageSizeDialog) || 1;
      }
      for (let i = 0; i < this.pageNumDialog; i++) {
        this.totalPageDataDialog[i] = this.historyList.slice(
          this.pageSizeDialog * i,
          this.pageSizeDialog * (i + 1)
        );
      }

      this.dataShowDialog = this.totalPageDataDialog[
        this.currentPageDialog - 1
      ];
    },
    handleSizeChangeDialog(val) {
      this.pageSizeDialog = val;
      this.calcPageDataDialog();
    },
    handleCurrentChangeDialog(val) {
      this.currentPageDialog = val;
      this.dataShowDialog = this.totalPageDataDialog[val - 1];
    }
  }
};
</script>
<style scoped>
.el-main {
  margin: 0px;
  padding: 0px;
  background: #f5f7fa;
}
.owner_title {
  font-size: 17px;
  font-family: Source Han Sans CN-Regular, Source Han Sans CN;
  font-weight: 400;
  color: #304265;
  background: #ffffff;
  padding: 15px;
  border: 1px solid #e4e9f1;
}
.seas_box {
  margin: 0px 15px;
}
.task_btn {
  /* width: 90px;
  height: 25px;
  text-align: center;
  line-height: 5px; */
  background: #f3f8ff;
  color: #157df8;
}
.mywriter_btn {
  width: 110px;
  height: 20px;
  line-height: 20px;
  text-align: center;
  background: #157df8;
  border-radius: 10px;
  font-size: 12px;
  font-family: Source Han Sans CN-Regular, Source Han Sans CN;
  font-weight: 400;
  color: #ffffff;
}
.mywriter_btn i {
  font-size: 12px;
}
.info_icon {
  font-size: 12px;
}
.task_filtrate {
  text-align: right;
  padding: 10px 15px 10px 15px;
}
.task_filtrate i {
  font-size: 14px;
}
.task_filtrate span {
  font-size: 14px;
  font-family: Source Han Sans CN-Regular, Source Han Sans CN;
  font-weight: 400;
  color: #8893a7;
}
.task_filter_form {
  background: #ffffff;
  margin: 0px 15px;
  padding-top: 15px;
}
.pagination_box {
  float: right;
  margin-top: 15px;
  margin-right: 15px;
}
.sea_box {
  display: flex;
  align-items: center;
  justify-content: center;
}
.remark_btn {
  width: 90px;
  height: 20px;
  background: #e7f2ff;
  font-size: 12px;
  font-family: Source Han Sans CN-Regular, Source Han Sans CN;
  font-weight: 400;
  color: #157df8;
  border-radius: 10px;
  margin-left: 5px;
}
.remark_btn i {
  font-size: 12px;
}

.seas_box .el-tag {
  width: 90px;
  margin: 5px auto;
}
.el-tag {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  width: 70px;
  height: 20px;
  border-radius: 10px;
  margin-left: 15px;
}
@media screen and (max-width: 750px) and (min-width: 375px) {
  .mywriter_btn,
  .remark_btn {
    width: 50px;
  }
  .seas_box {
    margin-bottom: 150px;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/writer/WriterHighSeas.vue